import RankingTab from '@/components/dashboard/RankingTab.tsx';

export default function RankingPage() {
  return (
    <div className="animate-fade-in">
      <RankingTab />
    </div>
  );
}
